/* eslint-disable react/no-danger */
import React, { useCallback, useEffect, useState } from 'react';
import { t } from 'ttag';
import { Heading } from '@components';

export default function OrbitvuImage({ productId }) {
  const [orbitvuScript, setOrbitvuScript] = useState(
    () => window?.__INITIAL_STATE__?.orbitvuScript
  );
  const [orbitvuId, setOrbitvuId] = useState();

  const getOrbitvuId = useCallback(url => {
    const match = url.match(/\/\/orbitvu\.co\/share\/([a-zA-Z0-9]+)\//);
    return match ? match[1] : undefined;
  }, []);

  useEffect(() => {
    setOrbitvuScript(window?.__INITIAL_STATE__?.orbitvuScript);
  }, [productId]);

  useEffect(() => {
    if (orbitvuScript !== '' && orbitvuScript !== undefined) {
      setOrbitvuId(getOrbitvuId(orbitvuScript));

      const script = document.createElement('script');

      script.src = orbitvuScript;
      script.async = true;

      document.body.appendChild(script);

      return () => {
        document.body.removeChild(script);
      };
    }

    return () => {};
  }, [orbitvuScript, getOrbitvuId]);

  if (!orbitvuScript || !orbitvuId) return null;

  return (
    <div
      className="mx-2 my-8 flex flex-col items-center justify-evenly gap-2 rounded-lg bg-gradient-to-r from-teal-200 to-lime-200 p-4 md:gap-8 md:p-8 lg:mx-0 lg:flex-row"
      id="explore-product"
    >
      <div className="space-y-2 md:space-y-4">
        <svg
          className="h-10 w-10 rounded-full bg-white p-2"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
        >
          <path d="M12 1L21.5 6.5V17.5L12 23L2.5 17.5V6.5L12 1ZM5.49388 7.0777L12.0001 10.8444L18.5062 7.07774L12 3.311L5.49388 7.0777ZM4.5 8.81329V16.3469L11.0001 20.1101V12.5765L4.5 8.81329ZM13.0001 20.11L19.5 16.3469V8.81337L13.0001 12.5765V20.11Z" />
        </svg>

        <Heading
          as="h2"
          className="font-black text-white"
        >{t`Explore Your Product`}</Heading>
      </div>
      <div className="flex items-center justify-center">
        <div
          className="orbitvu-viewer cursor-grab overflow-hidden rounded-lg"
          style={{ width: '350px', height: '400px' }}
        >
          <div
            id={`ovContent-${orbitvuId}`}
            style={{
              background: `url(//cdn.orbitvu.co/share/${orbitvuId}/still/view?height=400&max_width=350) no-repeat center center`,
              width: '100%',
              height: '100%'
            }}
          />
        </div>
      </div>
    </div>
  );
}
